/* eslint-disable jsx-a11y/click-events-have-key-events */
/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 *
 * @flow
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classes from './Popup.module.css';

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount = () => {
    const { visible = false } = this.props;
    this.setState({ visible });
  };

  componentWillReceiveProps = props => {
    const { visible = false } = props;
    this.setState({ visible });
  };

  onClickPopup = e => {
    let className = null;
    const { defaultClose = true, onClick = null, closePopup } = this.props;
    if (e.target !== null) className = e.target.getAttribute('class');
    if (
      defaultClose &&
      className &&
      className !== null &&
      className.indexOf('Popup_containerStyle') > -1
    ) {
      closePopup && closePopup();
    } else if (onClick !== null) onClick(e);
  };

  render() {
    const { popupStyle, children, onClick } = this.props;
    const { visible = false } = this.state;
    if (visible) {
      return (
        <div
          role="button"
          className={classes.containerStyle}
          onClick={onClick || this.onClickPopup}
          tabIndex={0}
        >
          <div
            style={{
              background: 'white',
              width: '80%',
              display: 'flex',
              flexDirection: 'column',
              ...popupStyle,
            }}
          >
            {children}
          </div>
        </div>
      );
    }
    return null;
  }
}

Popup.propTypes = {
  popupStyle: PropTypes.any,
  children: PropTypes.any,
  defaultClose: PropTypes.bool,
  onClick: PropTypes.func,
};

Popup.defaultProps = {
  defaultClose: true,
  onClick: null,
};

export default Popup;
